module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/bg_note-5b5fd30373f5a55096872e9a6045b354.png";